var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('bs-search-field',_vm._b({on:{"input":_vm._resetSearch,"search":_vm._beginSearch},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},'bs-search-field',_vm._attributes,false))}
var staticRenderFns = []

export { render, staticRenderFns }